import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";
import save from "../../../assets/save-icon.png";
import cancel from "../../../assets/cancel-icon.png";

const RoleModify = (props) => {
  //#region React Hooks
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const roleNameInputRef = useRef();
  const remarkInputRef = useRef();

  const [editData, setEditData] = useState([]);
  const [inputError, setInputError] = useState([]);
  useEffect(() => {
    setEditData({
      ROLE_NAME:
        props.editData !== null
          ? props.editData.ROLE_NAME === null
            ? ""
            : props.editData.ROLE_NAME
          : "",
      REMARK:
        props.editData !== null
          ? props.editData.REMARK === null
            ? ""
            : props.editData.REMARK
          : "",
      ROLE_ID:
        props.editData !== null
          ? props.editData.ROLE_ID === null
            ? ""
            : props.editData.ROLE_ID
          : "",
    });
  }, [props.editData]);
  //#endregion

  //#region Modal Show/Hide
  const hideModal = () => {
    setInputError([]);
    props.onHide();
  };
  //#endregion

  //#region Save Edit
  const editBtnOnClick = () => {
    if (Object.values(inputError).filter((v) => v !== "").length === 0) {
      SaveEditRole();
    }
  };

  function SaveEditRole() {
    let functionName = "";

    try {
      functionName = props.page + SaveEditRole.name;

      props.onLoading(true, "Modifying role, please wait...");

      const data = {
        ROLE_ID: editData.ROLE_ID,
        ROLE_NAME: editData.ROLE_NAME.trim(),
        REMARK: editData.REMARK === undefined ? "" : editData.REMARK.trim(),
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
      };

      http
        .put("api/roles/UpdateRole", data, { timeout: 10000 })
        .then((response) => {
          if (response.data.DUPLICATE_ROLE_NAME === true) {
            toast.error("Role name already exist.");
          } else {
            toast.success("Role is successfully modified.");
            props.onReload();
            hideModal();
          }
        })
        .catch((err) => {
          toast.error("Failed to modify role. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      toast.error("Failed to modify role. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  }
  //#endregion

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const inputUnrequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputUnrequiredHandler.name;
      const id = event.target.id;
      const val = event.target.value;

      setEditData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <Modal show={props.showHide} onHide={hideModal} centered>
        <Modal.Header>
          <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
            <Modal.Title>MODIFY</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Comp.Input
            ref={roleNameInputRef}
            id="ROLE_NAME"
            label="Role Name*:"
            name="User Role"
            type="text"
            className="form-control"
            errorMessage={inputError.ROLE_NAME}
            value={editData.ROLE_NAME}
            onChange={inputRequiredHandler}
          />
          <Comp.Input
            ref={remarkInputRef}
            id="REMARK"
            label="Remark:"
            type="text"
            className="form-control"
            value={editData.REMARK}
            onChange={inputUnrequiredHandler}
          />
        </Modal.Body>
        <Modal.Footer>
          <div style={{ textAlign: "center", width: "100%" }}>
            <Comp.Button id="btnSave" onClick={editBtnOnClick}>
              Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            <Comp.Button id="btnCancel" type="cancel" onClick={hideModal}>
              Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
            </Comp.Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RoleModify;
